const SITE_URL = 'https://www.movimentorivoluzionefiscale.it'

function canonicalUrl(pathname = '/') {
  const url = new URL(pathname || '/', SITE_URL)
  if (url.origin !== SITE_URL) return `${SITE_URL}/`
  url.search = ''
  url.hash = ''
  if (!/\.[a-z0-9]+$/i.test(url.pathname) && !url.pathname.endsWith('/')) url.pathname += '/'
  return url.href
}

function absoluteImage(value) {
  if (!value) return undefined
  const url = new URL(value, `${SITE_URL}/`)
  if (url.protocol === 'http:') url.protocol = 'https:'
  return url.protocol === 'https:' ? url.href : undefined
}

function plainText(value = '') {
  return String(value)
    .replace(/<(script|style)\b[^>]*>[\s\S]*?<\/\1>/gi, '')
    .replace(/<[^>]+>/g, ' ')
    .replace(/&(?:nbsp|amp|quot|apos|lt|gt);/g, entity => ({ '&nbsp;': ' ', '&amp;': '&', '&quot;': '"', '&apos;': "'", '&lt;': '<', '&gt;': '>' }[entity]))
    .replace(/&#(\d+);/g, (_, code) => Number(code) <= 0x10ffff ? String.fromCodePoint(Number(code)) : '')
    .replace(/\s+/g, ' ').trim()
}

function summarize(value, limit = 170) {
  const text = plainText(value)
  if (text.length <= limit) return text
  const cut = text.slice(0, limit - 1)
  const boundary = cut.lastIndexOf(' ')
  return cut.slice(0, boundary > limit / 2 ? boundary : cut.length).trim() + '…'
}

function contentDescription(content, title) {
  const html = content && content.childMarkdownRemark && content.childMarkdownRemark.html
  const paragraphs = html && html.match(/<p\b[^>]*>[\s\S]*?<\/p>/gi) || []
  const paragraph = paragraphs.find(text => {
    const plain = plainText(text)
    return plain.length > 20 && !/^(?:CONTENUTO POLITICO[- ]INFORMATIVO|FATTI VERIFICATI|POSIZIONE POLITICA MRF)(?:\s*·\s*\d{1,2}\s+\S+\s+\d{4})?$/i.test(plain)
  })
  return summarize(paragraph || html || title)
}

function videoMetadata(content, title) {
  return {
    title: `Video: ${plainText(title)}`,
    description: summarize(`Video MRF: ${contentDescription(content, title)}`, 190),
  }
}

function articleSchema({ title, path, description, image, author, date }) {
  const url = canonicalUrl(path)
  const name = author && [author.nome, author.cognome].filter(Boolean).join(' ')
  const schema = {
    '@context': 'https://schema.org', '@type': 'Article',
    '@id': `${url}#article`, mainEntityOfPage: url, url,
    headline: title, description, inLanguage: 'it-IT',
    publisher: { '@type': 'Organization', name: 'Movimento Rivoluzione Fiscale', '@id': `${SITE_URL}/#organization`, url: `${SITE_URL}/` },
  }
  if (name) schema.author = { '@type': 'Person', name }
  if (image && absoluteImage(image)) schema.image = [absoluteImage(image)]
  // Preserve the source precision; never invent a publication time or modification date.
  if (typeof date === 'string' && /^\d{4}-\d{2}-\d{2}(?:T[^ ]+)?$/.test(date) && !Number.isNaN(Date.parse(date))) schema.datePublished = date
  return schema
}

function serializeSchema(value) { return JSON.stringify(value).replace(/</g, '\\u003c') }

module.exports = { canonicalUrl, absoluteImage, plainText, summarize, contentDescription, videoMetadata, articleSchema, serializeSchema }

